function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HouseholdFootprintIcons = exports.HouseholdFootprintGroup = void 0;
var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/objectDestructuringEmpty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _styles = require("../OnboardingGroup/OnboardingGroupPages/Shared/Layout/styles");
var _Shared = require("../OnboardingGroup/OnboardingGroupPages/Shared");
var _utils = require("../../utils");
var _components = require("../../components");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _styles2 = require("../../styles");
var _images = require("../../images");
var _HouseholdFootprintGroupController = require("./HouseholdFootprintGroupController");
var _styles3 = require("./styles");
var _locales = require("../../locales");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var HouseholdFootprintIcons = exports.HouseholdFootprintIcons = {
  appliances: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Footprints/Appliances.svg")
    }, props));
  }),
  cleaning: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Footprints/Cleaning.svg")
    }, props));
  }),
  electricity: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Footprints/Electricity.svg")
    }, props));
  }),
  furniture: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Footprints/Furniture.svg")
    }, props));
  }),
  gas: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Footprints/Gas.svg")
    }, props));
  }),
  home_improvement: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Footprints/HomeImprovement.svg")
    }, props));
  }),
  oil: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Footprints/Oil.svg")
    }, props));
  }),
  pet: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Footprints/Pet.svg")
    }, props));
  }),
  waste: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Footprints/Waste.svg")
    }, props));
  }),
  water: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Footprints/Water.svg")
    }, props));
  }),
  wood: (0, _react.memo)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SvgImage, Object.assign({
      image: require("../../images/Footprints/Wood.svg")
    }, props));
  })
};
var ContentContainer = (0, _react.memo)(function (_ref) {
  var children = _ref.children;
  var _useLayoutStyles = (0, _styles.useStyles)(),
    layoutStyles = _useLayoutStyles.styles;
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: _reactNative.Platform.OS === 'web' ? (0, _jsxRuntime.jsx)("main", {
      style: _reactNative.StyleSheet.flatten([layoutStyles.content]),
      id: "Content",
      tabIndex: -1,
      children: children
    }) : (0, _jsxRuntime.jsx)(_reactNative.View, {
      style: layoutStyles.content,
      children: children
    })
  });
});
var Items = (0, _react.memo)(function (_ref2) {
  var person = _ref2.person;
  (0, _useLang.useLang)();
  (0, _locales.useFootprintLang)();
  (0, _locales.useErrorLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles3.useStyles)(),
    styles = _useStyles.styles;
  var _Items = (0, _react.useCallback)(function () {
    return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: Object.keys(HouseholdFootprintIcons).filter(function (key) {
        var _person$metaHousehold;
        return typeof (person == null ? void 0 : (_person$metaHousehold = person.metaHouseholdFootprintKgCo2e) == null ? void 0 : _person$metaHousehold[key]) !== 'undefined' && person.metaHouseholdFootprintKgCo2e[key] > 0;
      }).sort(function (key1, key2) {
        var _value1 = person.metaHouseholdFootprintKgCo2e[key1];
        var _value2 = person.metaHouseholdFootprintKgCo2e[key2];
        if (_value1 > _value2) return -1;
        if (_value1 < _value2) return 1;
        if (key1 > key2) return 1;
        if (key1 < key2) return -1;
        return 0;
      }).map(function (key, index) {
        var _person$metaHousehold2;
        var Icon = HouseholdFootprintIcons[key];
        var _isFirst = index === 0;
        var _isOdd = !!((index + 1) % 2);
        var _householdValue = person == null ? void 0 : (_person$metaHousehold2 = person.metaHouseholdFootprintKgCo2e) == null ? void 0 : _person$metaHousehold2[key];
        var _personValue = _householdValue / ((person == null ? void 0 : person.householdMemberCount) || 1);
        return (0, _jsxRuntime.jsxs)(_reactNative.View, {
          style: [styles.row, _isFirst ? styles.row_first : undefined, _isOdd ? styles.row_odd : undefined],
          testID: "HouseholdFootprintItem-".concat(key),
          children: [(0, _jsxRuntime.jsx)(Icon, {
            style: styles.rowIcon
          }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
            style: styles.rowLabel,
            children: t("footprint:item.".concat(key))
          }), (0, _jsxRuntime.jsxs)(_reactNative.Text, {
            style: styles.rowValue,
            children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
              style: styles.rowValueNumber,
              children: t('format:number', {
                value: _personValue,
                maximumFractionDigits: 0
              })
            }), "kg"]
          }), (0, _jsxRuntime.jsxs)(_reactNative.Text, {
            style: styles.rowValue,
            children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
              style: styles.rowValueNumber,
              children: t('format:number', {
                value: _householdValue,
                maximumFractionDigits: 0
              })
            }), "kg"]
          })]
        }, key);
      })
    });
  }, [person, styles.row, styles.rowIcon, styles.rowLabel, styles.rowValue, styles.rowValueNumber, styles.row_first, styles.row_odd, t]);
  return (0, _jsxRuntime.jsx)(_Items, {});
});
var HouseholdFootprintGroup = exports.HouseholdFootprintGroup = (0, _react.memo)(function (_ref3) {
  var _ref3$controller = _ref3.controller,
    controller = _ref3$controller === void 0 ? new _HouseholdFootprintGroupController.HouseholdFootprintGroupController() : _ref3$controller;
  (0, _useLang.useLang)();
  (0, _locales.useFootprintLang)();
  (0, _locales.useErrorLang)();
  var _controller$useContro = controller.useController(),
    isLoading = _controller$useContro.isLoading,
    getHouseholdCount = _controller$useContro.getHouseholdCount,
    saveHousehold = _controller$useContro.saveHousehold,
    person = _controller$useContro.person,
    invalidateHouseholdData = _controller$useContro.invalidateHouseholdData;
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    spacing = _STYLES$useStyles.spacing,
    bp = _STYLES$useStyles.bp;
  var _useLayoutStyles2 = (0, _styles.useStyles)(),
    layoutStyles = _useLayoutStyles2.styles;
  var _useStyles2 = (0, _styles3.useStyles)(),
    styles = _useStyles2.styles,
    imageWidth = _useStyles2.imageWidth;
  var navigationContext = (0, _utils.useNavigationContext)();
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _value = _useState2[0],
    _setValue = _useState2[1];
  var _descriptionId = (0, _react.useMemo)(function () {
    return (0, _utils.GenerateId)();
  }, []);
  var _offsetY = (0, _react.useRef)(new _reactNative.Animated.Value(1)).current;
  var _doOnce = (0, _react.useRef)(false);
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    _isUpdating = _useState4[0],
    _setIsUpdating = _useState4[1];
  var _useState5 = (0, _react.useState)(),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    _message = _useState6[0],
    _setMessage = _useState6[1];
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    footprintPageLinkUrl = _useContext.footprintPageLinkUrl,
    dashboardPageLinkUrl = _useContext.dashboardPageLinkUrl;
  var _imageWidth = imageWidth;
  var _imageHeight = _imageWidth * _images.HouseholdHeightRatio;
  var _hasBackButton = !!footprintPageLinkUrl;
  var _hasMessage = !!_message;
  var _onBackButtonPress = function _onBackButtonPress() {
    if (!_hasBackButton) return;
    navigationContext.navigate(footprintPageLinkUrl);
  };
  var _onSaveButtonPress = function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _success;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _setIsUpdating(true);
            _context.next = 3;
            return saveHousehold(_value);
          case 3:
            _success = _context.sent;
            if (_success) {
              _setMessage(t('householdFootprintGroup:success'));
            } else {
              (0, _components.ShowMessage)({
                text: t('error:default'),
                isCloseable: true
              });
            }
            _context.next = 7;
            return invalidateHouseholdData();
          case 7:
            _setIsUpdating(false);
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function _onSaveButtonPress() {
      return _ref4.apply(this, arguments);
    };
  }();
  var _onChange = function _onChange(value) {
    _setValue(value);
    if (typeof _message !== 'undefined') {
      _setMessage(undefined);
    }
  };
  var _SpeechBubble = (0, _react.useCallback)(function (props) {
    return (0, _jsxRuntime.jsx)(_components.SpeechBubble, Object.assign({
      categoryLabel: t('householdFootprintGroup:speechBubbleCategory'),
      text: t('householdFootprintGroup:speechBubbleText')
    }, props));
  }, [t]);
  var _Image = (0, _react.useCallback)(function (_ref5) {
    var args = Object.assign({}, ((0, _objectDestructuringEmpty2["default"])(_ref5), _ref5));
    return (0, _jsxRuntime.jsx)(_images.HouseholdImage, Object.assign({}, args));
  }, []);
  (0, _react.useEffect)(function () {
    if (isLoading || _doOnce.current) return;
    _doOnce.current = true;
    _setValue(getHouseholdCount());
  }, [getHouseholdCount, isLoading]);
  if (isLoading) {
    return (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {});
  }
  return (0, _jsxRuntime.jsx)(_reactNative.View, {
    style: {
      flex: 1
    },
    children: (0, _jsxRuntime.jsxs)(_reactNative.KeyboardAvoidingView, {
      behavior: _reactNative.Platform.OS === 'ios' ? 'padding' : undefined,
      style: layoutStyles.container,
      testID: "HouseholdFootprintGroup",
      children: [(0, _jsxRuntime.jsx)(_components.TopBar, {
        style: layoutStyles.topBar,
        offsetY: _offsetY,
        showBackButton: _hasBackButton,
        onBackButtonPress: _onBackButtonPress,
        backButtonLabel: t('householdFootprintGroup:backButtonLabel'),
        logoLinkUrl: dashboardPageLinkUrl
      }), (0, _jsxRuntime.jsx)(_reactNative.Animated.ScrollView, {
        contentContainerStyle: layoutStyles.scrollContentContainer,
        keyboardShouldPersistTaps: "handled",
        keyboardDismissMode: "none",
        onScroll: _reactNative.Animated.event([{
          nativeEvent: {
            contentOffset: {
              y: _offsetY
            }
          }
        }], {
          useNativeDriver: _utils.useNativeDriver
        }),
        scrollEventThrottle: 16,
        children: (0, _jsxRuntime.jsx)(ContentContainer, {
          children: (0, _jsxRuntime.jsxs)(_components.Column.Container, {
            children: [(0, _jsxRuntime.jsxs)(_components.Column.Left, {
              children: [(0, _jsxRuntime.jsx)(_Shared.Heading, {
                nativeID: _descriptionId,
                children: t('householdFootprintGroup:title')
              }), (0, _jsxRuntime.jsx)(_components.Column.HiddenContent, {
                hidden: bp.desktop,
                children: (0, _jsxRuntime.jsx)(_Image, {
                  style: {
                    marginBottom: spacing.l,
                    width: _imageWidth,
                    height: _imageHeight
                  }
                })
              }), (0, _jsxRuntime.jsx)(_components.Form, {
                children: (0, _jsxRuntime.jsxs)(_components.FieldSet, {
                  legend: t('householdFootprintGroup:title'),
                  children: [(0, _jsxRuntime.jsx)(_components.NumberInput, {
                    label: t('householdFootprintGroup:fieldLabel'),
                    descriptionId: _descriptionId,
                    step: 1,
                    min: 0,
                    max: 20,
                    onChange: _onChange,
                    value: _value
                  }), (0, _jsxRuntime.jsx)(_components.Button, {
                    type: _components.ButtonType.brand,
                    label: t('householdFootprintGroup:saveButtonLabel'),
                    onPress: _onSaveButtonPress,
                    containerStyle: styles.saveButton
                  })]
                })
              }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
                style: {
                  marginTop: spacing.xxxl,
                  width: '100%'
                },
                children: [(0, _jsxRuntime.jsx)(_components.Heading, {
                  level: 2,
                  style: styles.tableHeading,
                  children: t('householdFootprintGroup:sharedFootprints.title')
                }), _isUpdating ? (0, _jsxRuntime.jsx)(_components.ActivityIndicator, {}) : (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
                  children: [_hasMessage && (0, _jsxRuntime.jsx)(_reactNative.View, {
                    style: styles.messageContainer,
                    children: (0, _jsxRuntime.jsx)(_reactNative.Text, {
                      style: styles.messageText,
                      children: _message
                    })
                  }), (0, _jsxRuntime.jsxs)(_reactNative.View, {
                    style: styles.table,
                    children: [(0, _jsxRuntime.jsxs)(_reactNative.View, {
                      style: styles.tableHead,
                      children: [(0, _jsxRuntime.jsx)(_reactNative.Text, {
                        style: styles.tableHeadLabel,
                        children: t('householdFootprintGroup:sharedFootprints.personLabel')
                      }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
                        style: styles.tableHeadLabel,
                        children: t('householdFootprintGroup:sharedFootprints.householdLabel')
                      })]
                    }), (0, _jsxRuntime.jsx)(Items, {
                      person: person
                    })]
                  })]
                })]
              })]
            }), (0, _jsxRuntime.jsxs)(_components.Column.Right, {
              children: [(0, _jsxRuntime.jsx)(_components.Column.HiddenContent, {
                hidden: bp.not([bp.desktop]),
                children: (0, _jsxRuntime.jsx)(_Image, {
                  style: {
                    marginBottom: spacing.xxl,
                    width: _imageWidth,
                    height: _imageHeight
                  }
                })
              }), (0, _jsxRuntime.jsx)(_SpeechBubble, {})]
            })]
          })
        })
      })]
    })
  });
});